import { faClose } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { Search, XCircle } from 'react-bootstrap-icons';
import { useParams } from 'react-router-dom';
import User from '../../../../../../libs/api/services/User';
import StickyNavigationContext from '../../../../../../libs/providers/StickyNavigationProvider';

export default function UserSelectionComponent({ onUserSelected, onUserSelectedDetails, defaultValue, clearOnSelect, className }) {
    const { id } = useParams();
    const refSearch = useRef()
    const [users, setUsers] = useState([]);
    const [details, setDetails] = useState(defaultValue ? defaultValue : '');
    const { canNavigate } = useContext(StickyNavigationContext)
    const [error, setError] = useState("");
    const search = (s) => {
        // Search API
        User.search({
            search: s
        })
            .then((result) => {
                setUsers(result);
                // this.setState({
                //     results: result
                // })
            })
            .catch((err) => {
                console.error(err)
                setError(err.message)
            })
    }

    useEffect(() => {
        if (id) {
            User.get(id)
                .then((res) => {
                    setDetails(res.firstName + " " + res.lastName)
                })
                .catch((err) => {
                    console.err(err)
                    setError(err.message)
                })
            // Get details from id
        }
    }, [id]);

    const navigateUser = (id) => {
        //{ onUserSelected ? onUserSelected(id) : canNavigate() }
        const User = users.find(u => u.id === id)
        refSearch.current.value = User.firstName + " " + User.lastName
        if (clearOnSelect)
            refSearch.current.value = ''
        else
            setDetails(User.firstName + " " + User.lastName)
        setUsers([])
        if (onUserSelected) onUserSelected(id)
        if (onUserSelectedDetails) onUserSelectedDetails(User)
    }

    const _handleClear = () => {
        setDetails('')
        refSearch.current.value = ''
        setUsers([])
    }

    return (
        <div className={"row ".concat(className)}>
            <div className={"col-12 ".concat(className)}>
                {
                    error
                        ?
                        <div className="text-danger">{error}</div>
                        :
                        <></>
                }
                <div className="d-flex position-relative">
                    <input
                        ref={refSearch}
                        onBlur={(e) => refSearch.current.placeholder = 'User search'}
                        onFocus={(e) => refSearch.current.placeholder = 'Start typing users name to search user'}
                        onChange={(e) => search(e.target.value)} defaultValue={details}
                        className='form-control bg-search-bar rounded-3 text-primary'
                        placeholder='User Search' />
                    {
                        !(refSearch.current && refSearch.current.value !== "")
                            ?
                            <div
                                onClick={(e) => { refSearch.current.select(); refSearch.current.placeholder = 'Start typing users name to search user' ;}}
                                className="d-flex align-items-center bg-buttons px-3 position-absolute rounded" style={{ right: '0px', top: '0px', bottom: '0px', fontWeight: 'bold' }}>
                                <Search />
                            </div>
                            :
                            <div
                                onClick={(e) => _handleClear()}
                                className="d-flex align-items-center bg-buttons px-3 position-absolute rounded" style={{ right: '0px', top: '0px', bottom: '0px', fontWeight: 'bold' }}>
                                <XCircle />
                            </div>
                    }

                </div>
                {
                    users.length > 0
                        ?
                        <div className='bg-search-bar-result rounded-3 text-dark position-absolute w-50' >
                            <FontAwesomeIcon onClick={(e) => setUsers([])} style={{ position: "absolute", right: 0, padding: "8px", zIndex: 99 }} fontSize={15} icon={faClose} />
                            <ul className='position-relative'>
                                {
                                    users.map((result) =>
                                        <li onClick={(e) => navigateUser(result.id)} key={result.id}>{result.firstName} {result.lastName}</li>
                                    )
                                }
                            </ul>
                        </div>
                        :
                        <></>
                }
            </div>
        </div>
    )
}
